import * as React from "react"
import { useEffect } from "react"
import { useSignal } from "@preact/signals-react"
import { array, object } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"
import { Box } from "@mui/material"

import {CATALOGUE_ROUTES, COMMON_FILTER_KEYS} from "@constants"
import { CommonFiltersCatalogue } from "@components"
import { useAppDefaultFilters } from "@hooks"
import { country, disabledCommonFiltersSubmit, isLoadingCommonFilters, isSystemBusy } from "@signals"
import { CatalogueDetailsIsEmpty } from "./@signals"


export default function CatalogueDetailsFilters() {
	const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(CATALOGUE_ROUTES.DETAILS_ID, CATALOGUE_ROUTES.ACCESS_KEY)
	const brandsWaiting = useSignal(true)
	const { isValid, errors } = useValidatorSeeker({
		country: country.value
		}, object({
			country: array().min(1, 'At least one country is required')
		})
	)

	useEffect(() => {
		callUserDefaultFilters()
	}, [])

    useEffect(() => {
        disabledCommonFiltersSubmit.value = !isValid
    }, [isValid])

	useEffect(() => {
        return () => disabledCommonFiltersSubmit.value = false
    }, []);

    useEffect(() => {
        if (!isLoadingDefaultFilters) brandsWaiting.value = false
    }, [isLoadingDefaultFilters])

    const normalizedUserFilters = userFilters?.country && !Array.isArray(userFilters.country)
        ? { ...userFilters, country: [userFilters.country] }
        : userFilters

    return <Box data-tour="catalogue-details-filters">
        <CommonFiltersCatalogue
		userFilters={normalizedUserFilters}
		isLoadingDefaultFilters={isLoadingDefaultFilters}
		components={{
			favFiltersOnlyLine: false,
			productsInStock: true
		}}
		compProps={{
			productsInStock: { grid: { md: 5 } },
			country: {
				error: errors?.country,
				grid: { md: 6 },
				value: country.value.length > 1 ? country.value[0] : country.value,
				onChange: (e) => {
					if (e.target.value?.length > 1)
						country.value = [e.target.value[1]]
					else if (e.target.value?.length === 1)
						country.value = [e.target.value[0]]
					else
						country.value = []
				}
			},
			brandCustomer: {
				grid: { md: 6 },
				waiting: brandsWaiting.value
			},
			favFilters: {
				allowedFilters: [COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND],
				dashboardKey: CATALOGUE_ROUTES.DETAILS_ID
			},
		}}
		onSubmit={() => {
			isSystemBusy.value = false
			CatalogueDetailsIsEmpty.value = false
			isLoadingCommonFilters.value = true
		}}
	/>
    </Box>
}